import { Outlet } from "react-router-dom";
import Sidebar from "@/components/Sidebar";
import MobileNav from "@/components/MobileNav";
import AiFloatingWidget from "@/components/AiFloatingWidget";
import PwaInstallBanner from "@/components/PwaInstallBanner";
import ChangePasswordModal from "@/components/ChangePasswordModal";

export default function Layout() {
  return (
    <div className="min-h-screen flex bg-slate-50">
      <Sidebar />
      <MobileNav />
      <main className="flex-1 min-w-0 overflow-x-hidden pt-14 lg:pt-0 pb-24">
        <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-6 lg:py-8">
          <Outlet />
        </div>
      </main>
      <AiFloatingWidget />
      <PwaInstallBanner />
      <ChangePasswordModal />
    </div>
  );
}
